import { CollectionPageEventTypes } from '../types';
import { createUserActionBigQueryEvent } from '../../../../../shared/utils/events/bigQuery/userAction';

const { header } = CollectionPageEventTypes;

export const CollectionPageBigQueryEvents = {
    [header.actions.shareWithTeam.clicked]: createUserActionBigQueryEvent('clicked_on_invite_team'),
    [header.actions.socialShare.clicked]: createUserActionBigQueryEvent('clicked_on_share_link'),
    [header.actions.edit.clicked]: createUserActionBigQueryEvent('clicked_on_edit_list'),
    [header.actions.delete.clicked]: createUserActionBigQueryEvent('clicked_on_delete_list'),
    [header.actions.copyCollection.clicked]: createUserActionBigQueryEvent('clicked_on_copy_list'),
};
